import { Footer, FooterBottom, FooterInfo, FooterLogo, FooterSocial } from '@/components/ui/footer'
import { Container } from '@/components/ui/grid'

/*
 * O recuo lateral que o registry põe em cada faixa do rodapé é zerado porque o
 * `Container` já traz o dele — os dois somariam, e a marca do rodapé deixaria
 * de alinhar com a do cabeçalho.
 */
const RECUO_NO_CONTAINER = 'px-0 lg:px-0'

/*
 * Footer institucional montado pelas partes do registry gov.br
 * (`@shadcn-govbr/footer`) — paleta escura por token, divisor superior e barra
 * de licença ao pé vêm de lá.
 *
 * Não há colunas de links (`FooterColumns`): o OMEC não tem, hoje, mapa de site
 * a publicar. A seção de redes sociais é renderizada a partir de
 * {@link REDES_SOCIAIS}, vazia de propósito — o DS especifica os alvos, mas não
 * os endereços, e os perfis oficiais da SBio/MMA não foram informados. Um ícone
 * de rede social apontando para um endereço adivinhado é pior do que a ausência
 * dele; preencha a lista quando os perfis chegarem do time de comunicação.
 */
const REDES_SOCIAIS: { rotulo: string; href: string }[] = []

const ORGAO =
  'Secretaria Nacional de Biodiversidade, Florestas e Direitos Animais — Ministério do Meio Ambiente'

export function AppFooter() {
  return (
    <Footer>
      {/* Versão em negativo da marca: o footer é superfície escura, e a marca
          colorida (`govbr.svg`, usada no header) tem a tinta desenhada para
          fundo claro. */}
      <Container>
        <FooterLogo className={RECUO_NO_CONTAINER}>
          <img src="/govbrNegativa.svg" alt="gov.br" />
        </FooterLogo>

        {REDES_SOCIAIS.length > 0 ? (
          <FooterBottom className={RECUO_NO_CONTAINER}>
            <FooterSocial>
              {REDES_SOCIAIS.map((rede) => (
                <a key={rede.rotulo} href={rede.href} aria-label={rede.rotulo}>
                  {rede.rotulo}
                </a>
              ))}
            </FooterSocial>
          </FooterBottom>
        ) : null}
      </Container>

      {/* A barra de licença fica fora do `Container`: o divisor no topo dela é
          uma linha de borda a borda, como o UIKIT desenha. */}
      <FooterInfo className="mt-(--spacing-scale-6x)">{ORGAO}</FooterInfo>
    </Footer>
  )
}
